/* ct-card-deck.js -- v21 S4 tier 2. This was a 12.5 KB inline <script> re-sent
   inside every document that renders the deck (6 collection/product templates).
   Inline cannot be cached; as an asset it is fetched once. Per-section tuning
   travels as JSON in data-deck-config on the section root; the script discovers
   every deck on the page by that attribute, so multiple decks keep working. */
(function () {
  'use strict';
  function initDeck(root) {
    if (!root || root.dataset.deckReady) return;
    root.dataset.deckReady = '1';

    var CFG = {};
    try { CFG = JSON.parse(root.getAttribute('data-deck-config') || '{}'); } catch (e) {}

    var deck  = root.querySelector('.ct-deck__deck');
    var track = root.querySelector('.ct-deck__track');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.ct-deck__card'));
    var copies = Array.prototype.slice.call(root.querySelectorAll('.ct-deck__copy-item'));
    var copyBox = root.querySelector('.ct-deck__copy');
    if (!cards.length) return;

    /* The copy was authored for the old flip card, whose back face was a narrow
       fixed panel, so the writer broke the lines by hand with U+2028 LINE
       SEPARATOR. Those are still in the block settings and the browser honours
       them, which is why the live card reads "Indulgencemeets nutritionwithout
       compromising ontexture" -- a break with no space either side. Nothing here
       wants hard breaks; the box reflows. Swapping them for spaces also removes
       the ragged short lines, which is most of the empty room in the box.
       Done in JS rather than a Liquid `replace` because a bare U+2028 in a
       .liquid file is invisible and the first tool that touches the file
       normalises it away. */
    copies.forEach(function (c) {
      if (/[\u2028\u2029]/.test(c.innerHTML)) {
        c.innerHTML = c.innerHTML.replace(/[\u2028\u2029]/g, ' ');
      }
    });

    /* Hold the box to the copy on screen instead of to the longest of the four.
       Only switched on once a height has been measured, so a browser that never
       runs this keeps the grid-stacked fallback. */
    function sizeCopy() {
      if (!copyBox) return;
      var on = copies[active];
      if (!on) return;
      var h = on.getBoundingClientRect().height || on.offsetHeight;
      if (!h) return;
      /* box-sizing is border-box theme-wide, so the height we set has to carry
         the padding with it. */
      var cs = getComputedStyle(copyBox);
      var pad = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
      copyBox.classList.add('is-measured');
      copyBox.style.height = Math.ceil(h + pad) + 'px';
    }
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { sizeCopy(); });
      copies.forEach(function (c) { ro.observe(c); });
    }

    /* Desktop splay. Scaled down from the reference's diff*20 / diff*24, which are
       tuned for 110px thumbnails; on a poster card those swing it 60deg. */
    var ROW = {
      rotRest:    CFG.restRot,
      rotHover:   CFG.splayRot,
      yHover:     CFG.splayLift,
      activeScale:CFG.focusScale,
      sibRest:    CFG.sibScale,
      sibHover:   CFG.sibScaleHover
    };
    /* Cover flow. zStep used to be a flat -160px, which pushed the neighbours so
       far back that perspective shrank them a second time on top of scaleStep
       and flattened the turn further. It is a setting now and much shallower. */
    var FLOW = {
      rot: CFG.flowRot,
      xStep: parseFloat(root.dataset.xstep) || 0.74,
      zStep: -CFG.flowDepth, activeZ: 40,
      scaleStep: 0.09, activeScale: CFG.flowFocusScale,
      opStep: 0.18, maxVisible: 3
    };

    var active = parseInt(root.dataset.start, 10) || 0;
    /* pos is the deck's position in card units and is allowed to be fractional
       while a finger is down, so the cards interpolate under the thumb instead
       of snapping a whole card at a time. At rest pos === active. */
    var pos = active;
    var splayed = false, dragged = false;

    function isRow() { return window.matchMedia('(min-width: 750px)').matches; }
    function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }

    function layoutRow() {
      cards.forEach(function (el, i) {
        var d = i - active, isA = i === active;
        var rot = d * (splayed ? ROW.rotHover : ROW.rotRest);
        var y = splayed ? d * ROW.yHover : 0;
        var sc = isA ? ROW.activeScale : (splayed ? ROW.sibHover : ROW.sibRest);
        /* transform order matches Motion's: translate, scale, rotate */
        el.style.transform = 'translateY(' + y + 'px) scale(' + sc + ') rotate(' + rot + 'deg)';
        el.style.opacity = 1;
        el.style.zIndex = isA ? 30 : 10;
        el.style.pointerEvents = 'auto';
        el.tabIndex = 0;
        el.dataset.active = isA ? 'true' : 'false';
      });
      track.style.removeProperty('--deck-track-h');
    }

    /* Every term is a continuous function of the fractional offset now, so a
       half-card drag renders a half-turned card. The old version switched on
       `o === 0`, which is only ever true at rest and would have popped. */
    function layoutFlow() {
      var w = cards[0].offsetWidth || 200;
      cards.forEach(function (el, i) {
        var o = i - pos, a = Math.abs(o), n = Math.min(a, 1), hid = a > FLOW.maxVisible + 0.5;
        var rot = -clamp(o, -1, 1) * FLOW.rot;
        var z = a <= 1 ? FLOW.activeZ + (FLOW.zStep - FLOW.activeZ) * n : FLOW.zStep * a;
        var sc = a <= 1
          ? FLOW.activeScale + (1 - FLOW.scaleStep - FLOW.activeScale) * n
          : Math.max(0.4, 1 - a * FLOW.scaleStep);
        el.style.transform =
          'translateX(' + (o * w * FLOW.xStep).toFixed(1) + 'px) ' +
          'translateZ(' + z.toFixed(1) + 'px) ' +
          'rotateY(' + rot.toFixed(2) + 'deg) ' +
          'scale(' + sc.toFixed(3) + ')';
        el.style.opacity = hid ? 0 : Math.max(0, 1 - a * FLOW.opStep).toFixed(2);
        el.style.zIndex = Math.round(100 - a * 10);
        el.style.pointerEvents = hid ? 'none' : 'auto';
        el.tabIndex = hid ? -1 : 0;
        el.dataset.active = a < 0.5 ? 'true' : 'false';
      });
      track.style.setProperty(
        '--deck-track-h',
        Math.round((cards[0].offsetHeight || 330) * FLOW.activeScale + 36) + 'px'
      );
    }

    function layout() {
      if (isRow()) layoutRow(); else layoutFlow();
      copies.forEach(function (c, i) { c.classList.toggle('is-on', i === active); });
      sizeCopy();
    }

    function go(i) {
      i = clamp(i, 0, cards.length - 1);
      var moved = i !== active;
      active = i;
      pos = i;
      layout();
      return moved;
    }

    /* Desktop: cards do not overlap, so a plain listener is reliable. */
    cards.forEach(function (el, i) {
      el.addEventListener('click', function (e) {
        if (isRow()) { e.stopPropagation(); go(i); }
      });
    });

    /* Cover flow: work out the card from the pointer position rather than asking
       the DOM. A rotateY'd, translateZ'd card is unreliable to hit-test, and the
       active card covers its neighbours' inner edges. */
    function indexAt(clientX) {
      var r = track.getBoundingClientRect();
      var step = (cards[0].offsetWidth || 200) * FLOW.xStep;
      return active + Math.round((clientX - (r.left + r.width / 2)) / step);
    }
    deck.addEventListener('click', function (e) {
      if (!isRow() && !dragged) go(indexAt(e.clientX));
    });

    /* The previous handler was pointerdown-on-track / pointerup-on-window with a
       45px threshold and no pointermove at all. Two things killed it: the deck
       had no touch-action, so the browser claimed the horizontal gesture and
       delivered pointercancel rather than pointerup; and with no move handler
       nothing tracked the finger, so even the swipes that did land felt like a
       button press with a delay. Pointer capture keeps the stream on this
       element once it starts, pointercancel is handled, and the deck follows
       the thumb. */
    var drag = null;

    function stepPx() { return (cards[0].offsetWidth || 200) * FLOW.xStep; }

    track.addEventListener('pointerdown', function (e) {
      if (isRow() || e.button > 0) return;
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, base: pos, moved: false, hist: [] };
      dragged = false;
      try { track.setPointerCapture(e.pointerId); } catch (err) { /* not fatal */ }
    });

    track.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved) {
        /* Commit to the axis once, so a mostly-vertical flick stays a page
           scroll instead of nudging the deck sideways. */
        if (Math.abs(dx) < 6 && Math.abs(e.clientY - drag.y) < 6) return;
        if (Math.abs(e.clientY - drag.y) > Math.abs(dx)) { drag = null; return; }
        drag.moved = true;
        root.classList.add('is-dragging');
      }
      drag.hist.push({ x: e.clientX, t: e.timeStamp });
      if (drag.hist.length > 6) drag.hist.shift();

      var next = drag.base - dx / stepPx();
      /* Rubber-band past the ends rather than stopping dead. */
      if (next < 0) next = next * 0.35;
      else if (next > cards.length - 1) next = cards.length - 1 + (next - (cards.length - 1)) * 0.35;
      pos = next;
      layoutFlow();
    });

    function endDrag(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      var d = drag;
      drag = null;
      root.classList.remove('is-dragging');
      if (!d.moved) return;
      dragged = true;
      setTimeout(function () { dragged = false; }, 0);

      /* Velocity from the last ~80ms of samples, projected forward so a flick
         carries past the halfway point instead of springing back. */
      var v = 0;
      if (d.hist.length > 1) {
        var a = d.hist[0], b = d.hist[d.hist.length - 1], dt = b.t - a.t;
        if (dt > 0) v = (b.x - a.x) / dt;
      }
      var target = Math.round(pos - clamp((v / stepPx()) * 140, -1, 1));

      /* The drag distance and the flick projection are separate contributions
         and they double-count: a brisk 150px swipe already carries 0.9 of a card
         before inertia adds a whole one on top, which landed two cards away from
         where the thumb was aiming. Inertia may finish the card the finger
         started, never add another -- so the result is held to the span the drag
         itself covered, with a floor of one so a short flick still pages. */
      var span = Math.max(1, Math.ceil(Math.abs(pos - d.base)));
      target = clamp(target, d.base - span, d.base + span);
      go(clamp(target, 0, cards.length - 1));
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('lostpointercapture', endDrag);

    /* Hover splays the whole hand. Guarded on pointer type so a touch device that
       reports a hover never sticks in the splayed state. */
    deck.addEventListener('mouseenter', function () {
      if (isRow() && window.matchMedia('(hover: hover)').matches) { splayed = true; layoutRow(); }
    });
    deck.addEventListener('mouseleave', function () {
      if (splayed) { splayed = false; layoutRow(); }
    });

    /* No chevrons and no dots, so the cards carry the whole interaction. Cursor
       tracks whether the pointer is over something that will actually move. */
    deck.addEventListener('pointermove', function (e) {
      if (isRow()) return;
      var i = indexAt(e.clientX);
      deck.style.cursor = (i !== active && i >= 0 && i < cards.length) ? 'pointer' : 'default';
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(active - 1);
      else if (e.key === 'ArrowRight') go(active + 1);
    });

    var wasRow = isRow();
    window.addEventListener('resize', function () {
      var now = isRow();
      if (now !== wasRow) {
        /* crossing the breakpoint: drop the other mode's inline styles */
        wasRow = now;
        splayed = false;
        cards.forEach(function (el) { el.style.cssText = ''; });
      }
      layout();
    });

    document.addEventListener('shopify:block:select', function (e) {
      if (root.contains(e.target)) go(parseInt(e.target.dataset.index, 10) || 0);
    });

    /* The heading sparkle ships at scale(0) and is revealed by a global GSAP
       ScrollTrigger in custom.js. That query runs once on load, so a section
       inserted live in the theme editor never gets picked up and the sparkle
       stays invisible. Reveal it directly in that case only. */
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target.contains(root) && e.target !== root.parentElement) return;
      var mark = root.querySelector('img.head-line');
      if (mark && getComputedStyle(mark).transform === 'matrix(0, 0, 0, 0, 0, 0)') {
        mark.style.transform = 'rotate(-21deg) scale(1)';
      }
    });

    layout();
  
  }
  function boot() {
    document.querySelectorAll('[data-deck-config]').forEach(initDeck);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
